export const geralDefault = {
  num_cnpj: '',
  num_ie: '',
  name: '',
  num_telefone: '',
  num_celular: '',
  des_contato: '',
  email: '',
  site: '',
  num_cep: '',
  des_logradouro: '',
  num_endereco: '',
  des_bairro: '',
  des_complemento: '',
  cidades: { label: undefined, value: undefined },
};

export const bandeirasDefault = {
  des_bandeira: '',
  cod_cc: { label: undefined, value: undefined },
  per_taxa_credito: '',
  num_condicao_credito: '',
  per_taxa_debito: '',
  num_condicao_debito: '',
  per_taxa_parcelado: '',
  num_condicao_parcela: '',
};
